import { model } from "core/util";
import { ElectronicCommunication as ElectronicCommunicationType } from "types";

export const ElectronicCommunicationV2 = model.createModel<ElectronicCommunicationType, ElectronicCommunicationType>((json) => ({
    electronicCommunicationSet: json.electronicCommunicationSet,
    electronicCommunicationType: json.electronicCommunicationType,
}));
